import React from 'react';
import { Image } from '@chakra-ui/react';
import logoImg from '/logo.png';
import { useAppInfoContext } from '../../contexts/AppInfoContext';

interface NewCompassLogoProps {
  boxSize?: number | string;
  color?: string;
}

export const NewCompassLogo: React.FC<NewCompassLogoProps> = ({ boxSize = 8, color }) => {
  const { appInfo } = useAppInfoContext();
  
  return (
    <Image
      src={logoImg}
      alt={`${appInfo.name} Logo`}
      boxSize={boxSize}
      objectFit="contain"
    />
  );
};

export default NewCompassLogo;